module.exports = __webpack_public_path__ + "static/media/category15.3fc1b5ca.jpg";